export const WORKSPACE_KEY = "tripcart_current_workspace";
export const WORKSPACE_ID_KEY = "tripcart_workspace_id";
export const WORKSPACE_NAME_KEY = "tripcart_workspace_name";
export const WORKSPACE_LOCKED_KEY = "tripcart_workspace_locked";
export const PREV_WORKSPACE_ID_KEY = "tripcart_prev_workspace_id";
